import { useEffect } from "react";
import { ActionsAdAssistant } from "../../../Actions/ActionsAdAssistant/ActionsAdAssistant";

/**
 * Custom hook to unlock all ads when the edit modal is not open.
 * @param {Array} selectedAds - Array of ad objects to unlock.
 * @param {Object} userProfile - User profile object containing the user ID.
 * @param {boolean} isEditModalOpen - Whether the edit modal is open.
 */
export function useCleanRealtimeAdLock({ selectedAds, userProfile, isEditModalOpen }) {
  // Unlock all ads when the edit modal is not open
  useEffect(() => {
    if (!isEditModalOpen && selectedAds.length > 0) {
      selectedAds.forEach((ad) => {
        const isUserLockedAd = ad.isLocked && ad.lockedUserId === userProfile.userId;

        if (isUserLockedAd) {
          ActionsAdAssistant.updateAd(
            {
              isLocked: false,
              lockedBy: null,
              lockedUserId: null
            },
            ad.id
          );
        }
      });
    }
  }, [isEditModalOpen, selectedAds, userProfile]);
}
